import React from "react";

const Index = () => {
  return <div>i am dashboard</div>;
};

export default Index;
